import { useState } from "react";
import { useStateManager } from "react-select";
import { DisplayContainer } from "../../../../components/DisplayContainer";
import { buildEndpoint } from "../../../../services/api.service";
import { IObra, IOperacao, IPeca } from "../IObra";
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

export default function PecaDisplay({ peca }: { peca: IPeca }) {


    const [expanded, setExpanded] = useState<boolean>(false);

    return (
        <div className="border w-full rounded-md p-2 mt-2 transition-all duration-400 hover:bg-zinc-200">
            <div className="flex justify-between">
                <div className="flex">
                    <DisplayContainer prop={"Referência"} val={peca.reference} className={"mr-3"} />
                    <DisplayContainer prop={"Quantidade"} val={peca.amount} className={"mr-3"} />
                    <DisplayContainer prop={"Material"} val={peca.material?.reference} className={"mr-3"} />
                </div>
                <div className="cursor-pointer">
                    {expanded ? <UnfoldLessIcon onClick={() => setExpanded(false)} /> : <UnfoldMoreIcon onClick={() => setExpanded(true)} />}
                </div>
            </div>
            {
                expanded ?
                    <div className={`${!expanded ? 'h-0' : 'h-auto'} overflow-hidden`}>
                        <div className="mt-2">
                            <span className="font-bold">Desenhos:</span>
                            {peca.desenhosTecnicos.map((d: any) => (<>
                                {
                                    (d.name.split('.')[d.name.split('.').length - 1] == 'stp' || d.name.split('.')[d.name.split('.').length - 1]?.toLowerCase() == 'step') ?
                                        <a className="p-2" href={buildEndpoint(`/pecas/${peca.id}/desenhos-tecnicos/download/${d.id}`)} download>
                                            <div >{d.name}</div>
                                        </a> :
                                        <a className="p-2" href={buildEndpoint(`/pecas/${peca.id}/desenhos-tecnicos/download/${d.id}`)} target='__blank'>
                                            <div >{d.name}</div>
                                        </a>
                                }
                            </>


                            ))}
                        </div>

                        <div className="mt-2">
                            <span className="font-bold">Operações:</span>
                            {peca.operacoes.map((o: IOperacao) => (
                                <div key={o.id} className="flex m-2 ml-0 border rounded-md p-1">
                                    <DisplayContainer prop={"Tipo"} val={o.tipo} className="mr-2" />
                                    <DisplayContainer prop={"Observações"} val={o.observacoes} className="mr-2" />
                                    <DisplayContainer prop={"Operação externa"} val={o.isExternal ? 'Sim' : 'Não'} className="mr-2" />

                                    {o.isExternal ? <DisplayContainer prop={"Data de saída"} val={o.dataExpedicao} /> : null}

                                </div>
                            ))}

                        </div>

                    </div>
                    : null
            }


        </div>

    )




}